// src/pages/CommentsPage.jsx
import React from 'react';
import './CommentsPage.css';

// 模拟数据
const DUMMY_COMMENTS = [
  { id: 1, user: "音乐狂人", avatar: "音", content: "太绝了！这里的副歌部分处理得比原版还要有感觉，AI现在已经进化到这个地步了吗？😱", time: "刚刚", likes: 24, isLiked: true },
  { id: 2, user: "Producer_J", avatar: "J", content: "贝斯的律动感很强，但是在高频部分稍微有点刺耳，建议再调节一下EQ。", time: "5分钟前", likes: 8, isLiked: false },
  { id: 3, user: "Alice", avatar: "A", content: "这种Lo-fi风格真的太适合深夜听了，已收藏！✨", time: "12分钟前", likes: 45, isLiked: true },
  { id: 4, user: "路人甲", avatar: "路", content: "好听好听好听！求完整版下载链接！", time: "20分钟前", likes: 2, isLiked: false },
  { id: 5, user: "Synthesizer", avatar: "S", content: "这个魔法改编功能有点东西，原本是爵士风，改成了电子风居然毫无违和感。", time: "35分钟前", likes: 15, isLiked: false },
  { id: 6, user: "猫咪爱吃鱼", avatar: "猫", content: "第一遍听：就这？\n第二遍听：有点意思。\n第三遍听：根本停不下来！！！💃💃💃", time: "1小时前", likes: 102, isLiked: true },
  { id: 7, user: "GuitarHero", avatar: "G", content: "吉他独奏那一段是AI生成的吗？简直像真人弹的一样，稍微有点泛音的感觉很真实。", time: "1小时前", likes: 33, isLiked: false },
  { id: 8, user: "CloudWalker", avatar: "C", content: "背景的雨声采样加分不少，氛围感拉满。", time: "2小时前", likes: 9, isLiked: false },
  { id: 9, user: "TechnoKing", avatar: "T", content: "鼓点稍微有点乱，不过整体创意是好的。期待下一个版本。", time: "3小时前", likes: 4, isLiked: false },
  { id: 10, user: "Vocaloid_Fan", avatar: "V", content: "这首歌的人声处理得很好，没有那种明显的电音机械感。", time: "4小时前", likes: 18, isLiked: false },
  { id: 11, user: "早睡早起", avatar: "早", content: "睡前必听系列。", time: "5小时前", likes: 6, isLiked: false },
  { id: 12, user: "BeatMaker2024", avatar: "B", content: "能不能出个教程教一下怎么调参数？我也想做出这种效果。", time: "6小时前", likes: 21, isLiked: false },
  { id: 13, user: "OldSchool", avatar: "O", content: "还是喜欢以前那种纯器乐的感觉，这个太现代了，不过年轻人应该喜欢。", time: "8小时前", likes: 3, isLiked: false },
  { id: 14, user: "未来之星", avatar: "未", content: "火钳刘明！这首歌一定会火的！🔥", time: "1天前", likes: 56, isLiked: true },
  { id: 15, user: "测试账号", avatar: "测", content: "这是一条很长很长的评论，用来测试换行显示的效果是否正常。如果不正常的话这行字就会溢出屏幕，希望程序员小哥哥能看到这条测试数据并修复它。", time: "2天前", likes: 0, isLiked: false },
];

function CommentsPage({ onBack }) {
  return (
    <div className="comments-page">
      <div className="comments-header">
        <button className="close-btn" onClick={onBack}>
          <i className="fas fa-chevron-down"></i>
        </button>
        <h2>99+ 条评论</h2>
      </div>

      {/* 
        注意：这里添加了 'h-scrollable' 类名 
        这会触发 App.jsx 中的逻辑，防止在滚动评论时触发页面的左右滑动
      */}
      <div className="comments-list h-scrollable">
        {DUMMY_COMMENTS.map((comment) => (
          <div key={comment.id} className="comment-item">
            <div className="comment-avatar">{comment.avatar}</div>
            <div className="comment-content-wrapper">
              <div className="comment-user-info">
                <span className="comment-username">{comment.user}</span>
                <span className="comment-time" style={{color: '#ccc', fontSize: '12px'}}>{comment.time}</span>
              </div>
              <p className="comment-text">{comment.content}</p>
              <div className="comment-actions">
                <div className={`action-item ${comment.isLiked ? 'liked' : ''}`}>
                  <i className={`${comment.isLiked ? 'fas' : 'far'} fa-heart`}></i>
                  <span>{comment.likes}</span>
                </div>
                <div className="action-item">
                  <i className="far fa-comment-alt"></i>
                  <span>回复</span>
                </div>
              </div>
            </div>
          </div>
        ))}
        {/* 底部垫高，防止最后一条被输入框遮挡 */}
        <div style={{ height: '20px' }}></div>
      </div>

      <div className="comments-input-area">
        <input type="text" placeholder="说点什么好听的..." />
        <button className="send-btn">发送</button>
      </div>
    </div>
  );
}

export default CommentsPage;